

export function addConfig(selectDeptClick,validateCurd) {
  return {
    labelWidth: 140,
    emptyBtn: false,
    submitBtn: false,
    column: [
      
      {
        label: "培训编号",
        prop: "number",
        span: 12,
        disabled: true,
        placeholder:'自动生成'
        // rules: [{
        //   required: true,
        //   message: "自动生成",
        //   trigger: "blur",
        // }, ],
      },
      {
        label: "资料主题",
        prop: "subject",
        span: 12,
        
        rules: [{
          required: true,
          message: "请输入资料主题",
          trigger: "blur",
        }, ],
      },
      {
        label: "上传部门",
        prop: "createDeptName",
        span: 12,
        disabled: true,
       
        
      },
      {
        label: "上传人",
        prop: "createUserName",
        span: 12,
        disabled: true,
       
      },
      {
        label: "材料说明",
        prop: "material",
        span: 24,
        
        rules: [{
          required: true,
          message: "请输入材料说明",
          trigger: "blur",
        }, ],
      },
      {
        label: "版权说明",
        prop: "copyright",
        span: 24,
        
        rules: [{
          required: true,
          message: "请输入版权说明",
          trigger: "blur",
        }, ],
      },
      {
        label: "课程封面",
        prop: "files",
        span: 24,
        formslot: true,
        rules: [{
          // type: "array",
          required: true,
          message: "请上传课程封面",
          trigger: "change",
        }, ],
      },

      {
        label: "是否允许下载",
        prop: "allowDownload",
        span: 24,
        type: 'radio',
              dicData:[{
          label:'是',
          value:1
        },{
          label:'否',
          value:0
        }],
        rules: [{
          required: true,
          message: "请选择是否允许下载",
          trigger: "change",
        }, ],
      },
      {
        label: "可见部门",
        prop: "visibleDeptName",
        span: 24,
        // formslot: true,
        rules: [{
          
          required: true,
          message: "请选择可见部门",
          trigger: "change",
        }, ],
        click: () => {
          selectDeptClick();
        }
      },
      
      {
        label: "",
        labelslot: true,
        labelWidth: 1,
        prop: "videos",
        span: 24,
        formslot: true,
        
        rules: [{
          type: "array",
          required: true,
          message: "请上传",
          trigger: "blur",
        },{ validator: validateCurd, trigger: 'blur' }],
      },

    ]
  }
}
export function uploadConfig() {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: false,
    searchShow: false,
    index: true,
    indexLabel: "序号",
    refreshBtn:false,
    column: [
      
      {
        label: "顺序号",
        placeholder: "请输入",
        prop: "seq",
        slot: true,
        width: "140",
        // overHidden: true
      },
      {
        label: "课程名称",
        placeholder: "请输入",
        prop: "name",
        slot: true,
        width: "200",
        overHidden: true
      },
      {
        label: "简要说明",
        placeholder: "请输入",
        prop: "intro",
        slot: true,
        width: "200",
        overHidden: true
      },
      {
        label: "附件",
        placeholder: "请输入",
        prop: "videoFiles",
        slot: true,
      //  width: "200",
        overHidden: true
      },
      {
        label: "上传时间",
        prop: "createTime",
        width: "140",
        overHidden: true
      },
      {
        label: "操作",
        placeholder: "请输入",
        prop: "action",
        slot: true,
        width: "100",
        overHidden: true
      },
      
    ]
  }
}